import { render } from "./DuotoneIcon.vue?vue&type=template&id=6dfd67b0"
import script from "./DuotoneIcon.vue?vue&type=script&lang=js"
export * from "./DuotoneIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__